import React from 'react';
import { CHECKOUT_URL } from '../data/checkout';
import { trackAddToCart } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  subLabel?: string;
  size?: 'md' | 'lg';
  href?: string;
  className?: string;
}
export function CtaButton({
  children,
  subLabel,
  size = 'lg',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-5 py-4 text-[13px] sm:px-8 sm:py-5 sm:text-base' : 'px-4 py-3 text-[11.5px] sm:px-6 sm:py-3.5 sm:text-sm';
  const handleClick = () => {
    if (href === CHECKOUT_URL) trackAddToCart();
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex flex-col items-center justify-center rounded-xl bg-[linear-gradient(135deg,#f0d580,#d4af37_45%,#a8862c)] text-center font-extrabold uppercase tracking-tight text-[#1a1400] shadow-[0_8px_30px_rgba(212,175,55,0.32)] outline-none transition-transform duration-200 animate-cta-glow hover:scale-[1.02] focus-visible:ring-2 focus-visible:ring-gold-light focus-visible:ring-offset-2 focus-visible:ring-offset-ink active:scale-[0.99] ${sizing} ${className}`} data-id="element-59" data-mp="109bx4x5uln8e">
      <span className="leading-tight" data-id="element-60" data-mp="3a0kmsydawmtn">{children}</span>
      {subLabel ? <span className="mt-1.5 text-[10px] font-semibold normal-case tracking-normal text-[#1a1400]/70" data-id="element-61" data-mp="3ewj82d3c1opu">
          {subLabel}
        </span> : null}
    </a>;
}